import styled from 'styled-components';
import Button from 'react-bootstrap/Button';

export const StyledButton = styled(Button)`
  background-color: ${(props) =>
    props.$selected ? props.theme.secondaryColor : props.theme.white};
  border: 1.5px solid ${(props) => props.theme.secondaryColor};
  color: ${(props) =>
    props.$selected ? props.theme.white : props.theme.secondaryColor};
  height: 100%;
  max-height: 3rem;
  width: ${(props) => props.$width};
  font-size: ${(props) => props.theme.fontSizeMd};
  font-weight: 500;

  &:hover {
    background-color: ${(props) =>
      props.$selected
        ? props.theme.secondaryColorDark
        : props.theme.secondaryColorLight};
    border-color: ${(props) => props.theme.secondaryColorDark};

    cursor: pointer;
  }
  &:focus {
  }

  ${(props) =>
    props.$disabled &&
    `
    background-color: ${props.theme.grayLight} !important;
    border-color: ${props.theme.grayDark} !important;
    color: ${props.theme.grayDark} !important;
    cursor: not-allowed !important;
    pointer-events: none;
    &:hover {
      background-color: ${props.theme.grayLight} !important;
      border-color: ${props.theme.grayDark} !important;
    }
  `}
  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    width: 100%;
    margin-right: 0.3rem;
  }
`;
